import axios from 'axios'
let baseURL = process.env.URL 

const service = axios.create({
  baseURL: baseURL, //基础路径
  timeout: 20000, //超时时间
})

//请求拦截器
service.interceptors.request.use(
  (config) => {
    config.headers['anonymousId'] = sensors.quick('getAnonymousID');
    config.headers['Accept-Language'] = 'en';
    config.headers['APP_TYPE'] = 'WEB'
    localStorage.getItem('token')?config.headers['token'] =localStorage.getItem('token'):'';
    return config
  }
)

//相应拦截器
service.interceptors.response.use(
  (response) => {
     // 统一处理token失效
     if(response.data.code == 401){
      localStorage.removeItem('token')
      Message.error(response.data.message)
      // this.$message.info(response.data.message)
    }
    return response.data
  },
  (error) => {
    // alert("发送请求失败" || "未知错误")
    //错误需不需要后面还能继续处理，关键看这里怎么写
    //如果想继续后面可以处理这个错误
    // return Promise.reject(new Error('发送ajax请求失败'))
    //如果后面不再对这个错误进行处理
    return new Promise(() => { }) //中断promise链
  }
)

export default service



// WEBPACK FOOTER //
// ./src/api/ajax.js